import { REPORT, REPORT_RANGE } from '@consts/reports';
import { BaseReport } from '../BaseReport';
import { useReportLoad } from '@hooks/useReportLoad';
import { countUnique, countUniqueTime } from '@utils/summaries';
import { basicSort, dateSort } from '@utils/sort';
import { styleTime } from '@utils/styles';

export const LocationsNoCutsLastWeek = () => {
    const { data, hasData, loading } = useReportLoad({
        reportType: REPORT.ISSUES_LOCATIONS_HAVE_NOT_CUT_IN_PAST_SEVEN_DAYS,
        params: {},
    });

    return (
        <BaseReport
            title={'Locations that Haven’t Cut in The Past 7 days'}
            description={'This is a list of locations which have not made a cut in the past 7 days.'}
            loading={loading}
            hasData={hasData}
            tableOptions={{
                headers: ['Location Name', 'Last Successful Cuts'],
                data: data.map((item) => [item.locationName, item.lastSuccessfulCut]),
                style: [null, styleTime],
                summaries: [countUnique, countUniqueTime],
                sort: [basicSort, dateSort(REPORT_RANGE.DAILY)],
            }}
        />
    );
};
